const MediaIndex = () => 
  import(/* webpackChunkName: 'MediaIndex' */ '@/Media/Index');

export default [
  {
    path: '/videos',
    name: 'videos',
    component: MediaIndex,
    props: route => ({
      page: Number(route.query.p || 1),
      filter: route.query.f,
      sortOrder: route.query.so,
      sortField: route.query.sf,
    }),
    meta: { auth: true },
  },
];
